import { z } from 'zod';
import {
  PaginationQueryParamsSchema,
  PaginationResponseSchema,
} from '@terra/shared-dto-types';

export const UserFilterQuerySchema = z.object({
  tenantIds: z.array(z.string()).optional(),
  roleNames: z.array(z.string()).optional(),
  statuses: z.array(z.enum(['invited', 'enabled', 'disabled'])).optional(),
  emails: z.array(z.email()).optional(),
  phones: z.array(z.string()).optional(),
  testUsersOnly: z.coerce.boolean().optional(),
  withTestUser: z.coerce.boolean().optional(),
});

export const GetUsersQuerySchema = PaginationQueryParamsSchema.extend({
  tenantIds: z.array(z.string()).optional(),
  roleNames: z.array(z.string()).optional(),
  statuses: z.array(z.enum(['invited', 'enabled', 'disabled'])).optional(),
  emails: z.array(z.email()).optional(),
  phones: z.array(z.string()).optional(),
  testUsersOnly: z.coerce.boolean().optional(),
  withTestUser: z.coerce.boolean().optional(),
});

export const GetUsersResponseSchema = z.object({
  users: z.array(z.any()),
  pagination: PaginationResponseSchema,
});

export const ErrorResponseSchema = z.object({
  message: z.string(),
  error: z.string().optional(),
});
